import _isObjectLike from "lodash/isObjectLike";
import _isFunction from "lodash/isFunction";
export function isPromise(val) {
    return _isObjectLike(val) && _isFunction(val.then) && _isFunction(val.catch);
}
export function fulfillPromise(promise) {
    if (isPromise(promise)) {
        promise?.then(() => { }, () => { });
    }
}
